module.exports = __webpack_public_path__ + "media/images/gallery/gal_s-006c3de0bfc2493d470f4be3f046efcc.gif";